/**
 * Convert string to array
 * @param {string} list
 */
const ConvertToArray = function (list) {
    if (list) {
        return list.split(',');
    }
    return [];
};
export default ConvertToArray;
